import { Stack, styled, Typography } from "~/common/mui";
import { t } from "i18next";
import B2CRequestCartList from "./B2CRequestCartList";
import type { CartElement } from "./CartElement";

interface B2CRequestItemsSectionProps {
  items: CartElement[];
}

const RequestItemsTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.headlineSmall,
  margin: 0,
  [theme.breakpoints.up("tablet")]: {
    ...theme.typography.headlineMedium,
  },
}));

export const B2CRequestItemsSection = ({ items }: B2CRequestItemsSectionProps) => (
  <Stack gap={2}>
    <RequestItemsTitle as="h2">{t("cartPage.toBeRequested", { count: items.length })}</RequestItemsTitle>
    <B2CRequestCartList items={items} />
  </Stack>
);
